// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as OrderType from "../../../../library/data-source/order/entity/OrderType.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as FilterOrderBrand from "../entity/FilterOrderBrand.bs.js";
import * as FilterOrderSource from "../entity/FilterOrderSource.bs.js";
import * as FilterOrderStatus from "../entity/FilterOrderStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as StringUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.bs.js";

function appendToParam(params, key, value) {
  if (value !== undefined) {
    params[key] = value;
    return ;
  }
  
}

function execute(request) {
  return $$Array.fold_left((function (dict, param) {
                dict[param[0]] = param[1];
                return dict;
              }), {}, [
              [
                "order_id",
                Belt_Option.getWithDefault(request.order_id, "")
              ],
              [
                "customer_mobile",
                Belt_Option.getWithDefault(request.customer_mobile, "")
              ],
              [
                "email",
                Belt_Option.getWithDefault(request.email, "")
              ],
              [
                "msisdn",
                Belt_Option.getWithDefault(request.msisdn, "")
              ],
              [
                "driver_mobile",
                Belt_Option.getWithDefault(request.driver_mobile, "")
              ],
              [
                "source",
                Belt_Option.mapWithDefault(request.source, "", FilterOrderSource.toString)
              ],
              [
                "geo_region",
                Belt_Option.getWithDefault(request.geo_region, "")
              ],
              [
                "order_status",
                Belt_Option.mapWithDefault(request.order_status, "", FilterOrderStatus.toString)
              ],
              [
                "order_type",
                Belt_Option.mapWithDefault(request.order_type, "", OrderType.toString)
              ],
              [
                "start_epoch_millis",
                Belt_Option.mapWithDefault(request.start_datetime, "", (function (date) {
                        return Timestamp$Catalyst.toFloat(date).toString();
                      }))
              ],
              [
                "end_epoch_millis",
                Belt_Option.mapWithDefault(request.end_datetime, "", (function (date) {
                        return Timestamp$Catalyst.toFloat(date).toString();
                      }))
              ],
              [
                "brand",
                Belt_Option.mapWithDefault(request.brand, "", FilterOrderBrand.toString)
              ],
              [
                "is_delivery_note_requested",
                Belt_Option.mapWithDefault(request.is_dn_requested, "false", (function (is_dn_requested) {
                        if (is_dn_requested) {
                          return "true";
                        } else {
                          return "false";
                        }
                      }))
              ],
              [
                "is_business",
                Belt_Option.mapWithDefault(request.is_business, "false", (function (is_business) {
                        if (is_business) {
                          return "true";
                        } else {
                          return "false";
                        }
                      }))
              ]
            ]);
}

var DictEncoder = {
  execute: execute
};

function getFromDict(dict, key, fromString) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                if (str.length !== 0) {
                  return Caml_option.some(Curry._1(fromString, str));
                }
                
              }));
}

function getFromDictString(dict, key) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                return str;
              }));
}

function getDefaultDateTime(time) {
  if (typeof time === "number") {
    if (time !== 0) {
      return Timestamp$Catalyst.endOf(Timestamp$Catalyst.now(undefined), /* Day */5);
    } else {
      return Timestamp$Catalyst.startOf(Timestamp$Catalyst.now(undefined), /* Day */5);
    }
  } else {
    return Timestamp$Catalyst.make(Number(time._0));
  }
}

function execute$1(map) {
  var order_id = getFromDictString(map, "order_id");
  return {
          order_id: order_id,
          customer_mobile: getFromDictString(map, "customer_mobile"),
          email: getFromDictString(map, "email"),
          msisdn: getFromDictString(map, "msisdn"),
          driver_mobile: getFromDictString(map, "driver_mobile"),
          source: getFromDict(map, "source", FilterOrderSource.fromString),
          order_status: getFromDict(map, "order_status", FilterOrderStatus.fromString),
          geo_region: getFromDictString(map, "geo_region"),
          order_type: getFromDict(map, "order_type", OrderType.fromString),
          start_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "start_epoch_millis"), StringUtils$Catalyst.getStringOptional), Belt_Option.isNone(order_id) ? Caml_option.some(getDefaultDateTime(/* Start */0)) : undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          end_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "end_epoch_millis"), StringUtils$Catalyst.getStringOptional), Belt_Option.isNone(order_id) ? Caml_option.some(getDefaultDateTime(/* End */1)) : undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          brand: getFromDict(map, "brand", FilterOrderBrand.fromString),
          virtual_number: getFromDictString(map, "virtual_number"),
          is_dn_requested: Belt_Option.map(getFromDictString(map, "is_delivery_note_requested"), (function (str) {
                  return str === "true";
                })),
          is_business: Belt_Option.map(getFromDictString(map, "is_business"), (function (str) {
                  return str === "true";
                }))
        };
}

var DictDecoder = {
  getFromDict: getFromDict,
  getFromDictString: getFromDictString,
  getDefaultDateTime: getDefaultDateTime,
  execute: execute$1
};

function getFromJson(json, key, fromString) {
  return Belt_Option.flatMap(Json_decode.optional((function (param) {
                    return Json_decode.field(key, Json_decode.string, param);
                  }), json), (function (value) {
                return Caml_option.some(Curry._1(fromString, value));
              }));
}

function getFromJsonString(json, key) {
  return Belt_Option.flatMap(Json_decode.optional((function (param) {
                    return Json_decode.field(key, Json_decode.string, param);
                  }), json), (function (value) {
                return value;
              }));
}

function execute$2(json) {
  return {
          order_id: getFromJsonString(json, "order_id"),
          customer_mobile: getFromJsonString(json, "customer_mobile"),
          email: getFromJsonString(json, "email"),
          msisdn: getFromJsonString(json, "msisdn"),
          driver_mobile: getFromJsonString(json, "driver_mobile"),
          source: getFromJson(json, "source", FilterOrderSource.fromString),
          order_status: getFromJson(json, "order_status", FilterOrderStatus.fromString),
          geo_region: getFromJsonString(json, "geo_region"),
          order_type: getFromJson(json, "order_type", OrderType.fromString),
          start_datetime: getFromJson(json, "start_epoch_millis", (function (s) {
                  return Timestamp$Catalyst.make(Number(s));
                })),
          end_datetime: getFromJson(json, "end_epoch_millis", (function (s) {
                  return Timestamp$Catalyst.make(Number(s));
                })),
          brand: getFromJson(json, "brand", FilterOrderBrand.fromString),
          virtual_number: getFromJsonString(json, "virtual_number"),
          is_dn_requested: Json_decode.optional((function (param) {
                  return Json_decode.field("is_delivery_note_requested", Json_decode.bool, param);
                }), json),
          is_business: Json_decode.optional((function (param) {
                  return Json_decode.field("is_business", Json_decode.bool, param);
                }), json)
        };
}

var JsonDecoder = {
  getFromJson: getFromJson,
  getFromJsonString: getFromJsonString,
  execute: execute$2
};

function execute$3(request) {
  var param = Belt_Option.flatMap(request.source, (function (source) {
          return FilterOrderSource.toString(source);
        }));
  var param$1 = Belt_Option.flatMap(request.order_status, (function (order_status) {
          return FilterOrderStatus.toString(order_status);
        }));
  var param$2 = Belt_Option.flatMap(request.order_type, (function (order_type) {
          return OrderType.toString(order_type);
        }));
  var param$3 = Belt_Option.flatMap(request.start_datetime, (function (date) {
          return Timestamp$Catalyst.toFloat(date).toString();
        }));
  var param$4 = Belt_Option.flatMap(request.end_datetime, (function (date) {
          return Timestamp$Catalyst.toFloat(date).toString();
        }));
  var param$5 = Belt_Option.flatMap(request.brand, (function (brand) {
          return FilterOrderBrand.toString(brand);
        }));
  return Json_encode.object_({
              hd: [
                "order_id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), request.order_id)
              ],
              tl: {
                hd: [
                  "customer_mobile",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), request.customer_mobile)
                ],
                tl: {
                  hd: [
                    "email",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), request.email)
                  ],
                  tl: {
                    hd: [
                      "msisdn",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), request.msisdn)
                    ],
                    tl: {
                      hd: [
                        "driver_mobile",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), request.driver_mobile)
                      ],
                      tl: {
                        hd: [
                          "source",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), param)
                        ],
                        tl: {
                          hd: [
                            "order_status",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), param$1)
                          ],
                          tl: {
                            hd: [
                              "geo_region",
                              Json_encode.nullable((function (prim) {
                                      return prim;
                                    }), request.geo_region)
                            ],
                            tl: {
                              hd: [
                                "order_type",
                                Json_encode.nullable((function (prim) {
                                        return prim;
                                      }), param$2)
                              ],
                              tl: {
                                hd: [
                                  "start_epoch_millis",
                                  Json_encode.nullable((function (prim) {
                                          return prim;
                                        }), param$3)
                                ],
                                tl: {
                                  hd: [
                                    "end_epoch_millis",
                                    Json_encode.nullable((function (prim) {
                                            return prim;
                                          }), param$4)
                                  ],
                                  tl: {
                                    hd: [
                                      "brand",
                                      Json_encode.nullable((function (prim) {
                                              return prim;
                                            }), param$5)
                                    ],
                                    tl: {
                                      hd: [
                                        "virtual_number",
                                        Json_encode.nullable((function (prim) {
                                                return prim;
                                              }), request.virtual_number)
                                      ],
                                      tl: {
                                        hd: [
                                          "is_delivery_note_requested",
                                          Json_encode.nullable((function (prim) {
                                                  return prim;
                                                }), request.is_dn_requested)
                                        ],
                                        tl: {
                                          hd: [
                                            "is_business",
                                            Json_encode.nullable((function (prim) {
                                                    return prim;
                                                  }), request.is_business)
                                          ],
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var JsonEncoder = {
  execute: execute$3
};

export {
  appendToParam ,
  DictEncoder ,
  DictDecoder ,
  JsonDecoder ,
  JsonEncoder ,
  
}
/* Timestamp-Catalyst Not a pure module */
